
import { i18nText } from '@/locales';

    import { StoreFormData, StoreFormRules } from "@/form/Warehouse/Store/Store";
    import { checkUserRole, getUserData } from "@/router/Lib/helper";
    import { StoresTypes } from "@/store/modules/Warehouse/StoresTypes";
    import { SalonsMix } from "@/UI/mixins/SalonsMix";
    import { StoreTypeMix } from "@/UI/mixins/Store/StoreTypeMix";
    import { Component, Vue } from "vue-property-decorator";
    import { mixins } from "vue-class-component";
    import PageTitle from "@/UI/components/common/PageTitle.vue";

    import { StoreMix } from "@/UI/mixins/Store/StoreMix";
    import { StoreTableMix } from "@/UI/mixins/Store/StoreTableMix";
    import { StoresStore } from "@/store/modules/Warehouse/Warehouse";
    import AppSimpleLink from "@/UI/components/Link/AppSimpleLink.vue";
    import BaseDataForm from "@/UI/components/Helpers/BaseForm/BaseDataForm.vue";
    import { Icon, Button, Table, Select, FormModel, Input, Modal, Row, Radio, message } from "ant-design-vue";
    import { AppStateStore } from "@/store/modules/appState";
    import { ProxyTableData } from "@/UI/components/Helpers/ProxyTableData";
    import { showNotification } from "@/UI/lib/messages";
    import { getStudioId } from "@/UI/lib/state";
    import SortComponent from "@/UI/components/Helpers/components/SortComponent.vue"
    import {appPaginationStore} from "@/store/modules/appPagination";
    import {ProxyGetData} from "@/UI/components/Helpers/getData";

    @Component({
        components: {
            "a-icon": Icon,
            "a-button": Button,
            "a-table": Table,
            "a-select": Select,
            "a-select-option": Select.Option,
            "a-form-model-item": FormModel.Item,
            "a-form-model": FormModel,
            "a-input": Input,
            "a-modal": Modal,
            "a-row": Row,
            "a-radio": Radio,
            "a-radio-group": Radio.Group,

            PageTitle,
            AppSimpleLink,
            BaseDataForm,
            SortComponent
        },
        methods: {
            checkUserRole,
            getUserData,
        },
    })
    export default class Index extends mixins(StoreMix, StoreTableMix, StoreTypeMix, SalonsMix, ProxyGetData, ProxyTableData) {
        showModal = false;
        modalTitle = "";
        modalMode = 0;
        storeEditMode = 0;
        loading = true;

        //RouterName = RouterNameEnum;
        form = new StoreFormData(getStudioId(this));
        rules = StoreFormRules;

        allowSave(): boolean {
            let result = false;
            //this.$refs.ruleForm.resetFields();
            if (this.$refs["StoreForm"] !== undefined) {
                (this.$refs["StoreForm"] as FormModel).validate((valid: boolean) => {
                    if (valid) {
                        result = true;
                    }
                });
            }
            return result;
        }
        cancelRemove(): void {
            this.showModal = false;
        }
        async removeStore(): Promise<void> {
            await StoresStore.delete(this.$store.state["warehouse"]["WarehouseItem"]["id"]).then((response) => {
                AppStateStore.setProxy(true);
                this.$notification.open({
                    message: i18nText("Удаление склада"),
                    description: response["response"],
                    duration: 0,
                });
                this.showModal = false;
                this.fetchTable(this);
            });
        }
        addCategory(): void {
            console.log("add category showModal");
            this.form = new StoreFormData(getStudioId(this));

            this.modalTitle = i18nText("Добавить склад");
            this.storeEditMode = 0;
            this.showModal = true;
            //this.$emit('delete');
            //Vue.set('showModal',true)
            //this.showModal = true
        }
        handleCancel(): void {
            this.showModal = false;
        }
        onSubmit(): void {
            (this.$refs.StoreForm as FormModel).validate((valid) => {
                try {
                    if (this.storeEditMode === 0) {
                        if (valid) {
                            try {
                                StoresStore.create(this.form).then((response) => {
                                    showNotification(i18nText("Добавление склада -") + this.form.name, response);
                                    this.fetchTable(this);
                                });
                            } catch (e) {
                                message.error(i18nText("Ошибка складской операции -") + e);
                            } finally {
                                this.showModal = false;
                            }
                        }
                        //await ProductsStore.create(this.$props.form)
                    }
                    if (this.storeEditMode === 1) {
                        if (valid) {
                            StoresStore.update(this.form);
                            this.$message.info(i18nText("Склад успешно обновлен!"));
                            this.showModal = false;
                        }
                    }
                } catch (e) {
                    console.log("Error save data -" + e);
                } finally {
                    StoresStore.fetchAll({filter: {salon_id: getStudioId(this)}})
                }
            });
        }
        async moveOperation(record: any): Promise<void> {
            console.log("Move link");
            await Vue.router.push({
                name: String(this.$routeRules.StoreOperationsMove),
                params: {
                    Studio: record["salon_id"],
                },
            });
        }
        async editCategory(record: any): Promise<void> {
            await StoresStore.fetchData({ filter: { id: record.id } }).then((data) => {
                if (this.store !== null) {
                    this.form.setFormData(this.store);
                    this.storeEditMode = 1;
                    this.showModal = true;
                }
            });
        }
        async created(): Promise<void> {
            //getStudioId(this);
            this.proxyFilter = {
                salon_id: getStudioId(this)
            }
            appPaginationStore.setCurrent(1)
            await this.createProxy();
            this.tableLoad = false;
            try {
                //await SalonsStore.fetchAll(filter);
                await StoresTypes.fetchAll();
                //await StoresStore.fetchAll({ limit: this.AppPageParams.pageSize })

                await this.sortedData('desc', {dataIndex: 'created_at'})
                await this.fetchModules([
                    {s: 'category', p: {limit: -1}}
                ])
            } catch (e) {
                console.log(e.message);
                console.log("Stores fetch Error");
            } finally {
                this.formReady = true;
                this.tableLoad = true;
            }
        }

        async setFilter({by, sort}: { by: string; sort: any }): Promise<void> {
            await this.sortedData(by, {dataIndex: sort.dataIndex})
        }
    }
